/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpinHistoryResultRange
 */
export interface SpinHistoryResultRange {
    /**
     * index (exclusive) of the last result included
     * @type {number}
     * @memberof SpinHistoryResultRange
     */
    resultEnd: number;
    /**
     * index (inclusive) of the first included result across the total result set
     * @type {number}
     * @memberof SpinHistoryResultRange
     */
    resultStart: number;
}

/**
 * Check if a given object implements the SpinHistoryResultRange interface.
 */
export function instanceOfSpinHistoryResultRange(value: object): value is SpinHistoryResultRange {
    if (!('resultEnd' in value) || value['resultEnd'] === undefined) return false;
    if (!('resultStart' in value) || value['resultStart'] === undefined) return false;
    return true;
}

export function SpinHistoryResultRangeFromJSON(json: any): SpinHistoryResultRange {
    return SpinHistoryResultRangeFromJSONTyped(json, false);
}

export function SpinHistoryResultRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinHistoryResultRange {
    if (json == null) {
        return json;
    }
    return {
        
        'resultEnd': json['resultEnd'],
        'resultStart': json['resultStart'],
    };
}

export function SpinHistoryResultRangeToJSON(value?: SpinHistoryResultRange | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'resultEnd': value['resultEnd'],
        'resultStart': value['resultStart'],
    };
}

